import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Normalize } from 'styled-normalize';
import { WrapPageElementBrowserArgs } from 'gatsby';
import { ErrorProvider, CartProvider, ToastProvider } from './contexts';
import MainLayout from './components/MainLayout';
import { setAuthToken } from './utils/httpClientUtil';
import './PageWrapperIncludes';
import 'focus-visible';

const StyledPageWrapper = styled.div`
  min-height: 70vh;
`;

const PageWrapper: React.FC<WrapPageElementBrowserArgs> = ({
  element,
}: WrapPageElementBrowserArgs): JSX.Element => {
  const isBrowser = typeof window !== 'undefined';
  useEffect(() => {
    setAuthToken();
  }, []);

  return !isBrowser ? (
    <></>
  ) : (
    <StyledPageWrapper>
      <ErrorProvider>
        <ToastProvider>
          <CartProvider>
            <Normalize />
            <MainLayout>{element}</MainLayout>
          </CartProvider>
        </ToastProvider>
      </ErrorProvider>
    </StyledPageWrapper>
  );
};

export default PageWrapper;
